import { render } from "./App.vue?vue&type=template&id=164281f2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=164281f2&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__